import { AsyncButton, Button } from '@components/button';
import { Typography } from '@components/typography';
import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';

export const StandardFormButtons = ({
  formKey,
  cancelLabel,
  formError,
  submitLabel,
  submitDisabled,
  onClose,
}: {
  formKey?: string;
  cancelLabel?: string;
  formError?: string;
  submitLabel?: string;
  submitDisabled?: boolean;
  onClose: () => void;
}) => {
  const { isValid, handleSubmit, dirty, isSubmitting, ...context } = useFormikContext();
  const status = context.status as { error: string };
  return (
    <Stack gap={4}>
      {(formError || status?.error) && (
        <Typography variant="body2" color="error">
          {formError || status?.error}
        </Typography>
      )}
      <AsyncButton
        fullWidth
        loading={isSubmitting}
        disabled={submitDisabled ?? !(isValid && dirty && !isSubmitting)}
        onClick={handleSubmit}
        data-cy={`${formKey || 'form'}-create-button`}
      >
        {submitLabel || 'Create'}
      </AsyncButton>
      <Button
        fullWidth
        variant="secondary"
        data-cy={`${formKey || 'form'}-cancel-button`}
        onClick={onClose}
      >
        {cancelLabel || 'Cancel'}
      </Button>
    </Stack>
  );
};
